/**
 * WHICH VERTICALS ARE LIVE, IN ONE PLACE, IN ONE VOCABULARY (2026-09-25).
 *
 * The marketing page's practice chips and the New brief dialog both say which verticals are live.
 * Two hand-typed copies of that fact would drift, and the page would then be lying about the one
 * subject it exists to be trusted on — so both read these values and these two words.
 *
 * `PROTEST_LIVE` moved here from `marketing/sections.tsx` unchanged: there is no protest route in
 * App.tsx, so `false` is the honest constant, not a placeholder. Appraisal support reads its flag.
 * BPO is live (it is built by the same builder). Flip a value here and both screens relabel.
 */
import { APPRAISAL_SUPPORT_ENABLED } from "./flags";

export const PROTEST_LIVE = false;

export const VERTICAL_LIVE = {
  protest: PROTEST_LIVE,
  bpo: true,
  appraisal_support: APPRAISAL_SUPPORT_ENABLED,
} as const;

/** The marketing page's own words, verbatim. */
export function statusWord(live: boolean): "Live now" | "Coming soon" {
  return live ? "Live now" : "Coming soon";
}
